import React from "react";

const projectsData = [
  {
    number: "01",
    title: "DocMind",
    link: "https://github.com/RupakBoral/docmind",
    github: "https://github.com/RupakBoral/docmind",
    description:
      "Query Transformation RAG system; ingests PDFs, embeds via Nomic Embed (Ollama), stores 768-dim vectors in pgvector.",
    stack: ["Node.js", "TypeScript", "Express.js", "PostgreSQL", "Docker"],
    type: "Backend / AI",
  },
  {
    number: "02",
    title: "Devity",
    link: "https://devity-frontend.onrender.com",
    github: "https://github.com/RupakBoral/Devity",
    description:
      "Full-stack platform for idea sharing and collaborative dev; 95+ Lighthouse score.",
    stack: [
      "React.js",
      "Redux",
      "Tailwind",
      "Node.js",
      "Express.js",
      "MongoDB",
    ],
    type: "Full Stack",
  },
  {
    number: "03",
    title: "PieScript",
    link: "https://github.com/RupakBoral/PieScript",
    github: "https://github.com/RupakBoral/PieScript",
    description:
      "Converts natural language prompts to animated educational videos with TTS and AI voice dubbing.",
    stack: [
      "React.js",
      "Node.js",
      "Manim",
      "Gemini API",
      "Groq API",
      "Murf API",
      "Cloudinary",
    ],
    type: "AI / Creative",
  },
  {
    number: "04",
    title: "Teler SDK for Node.js",
    link: "https://github.com/frejun-tech/teler-node",
    github: "https://github.com/frejun-tech/teler-node",
    description:
      "Published npm package providing a streamlined interface for Teler telephony in Node.js apps.",
    stack: ["Node.js", "WebSockets", "Teler", "Voice APIs"],
    type: "SDK / Open Source",
  },
];

const PortfolioHighlights = () => {
  return (
    <section
      id="work"
      className="layout-container py-24 md:py-32 border-t border-borderSubtle"
    >
      {/* Section Header */}
      <div className="flex flex-col">
        <span className="text-xs font-mono tracking-widest text-accent uppercase font-medium">
          <p>/ 03 / SELECTED WORK</p>
        </span>
        <h2 className="text-xl font-normal text-white mt-2">Projects & Code</h2>
      </div>

      {/* Projects List */}
      <div className="flex flex-col mt-12">
        {projectsData.map((project, index) => (
          <div
            key={index}
            className="group flex items-start gap-6 md:gap-8 py-8 border-b border-borderSubtle/50 last:border-b-0 border-l-2 hover:border-accent pl-4 md:pl-6 transition-all duration-300"
          >
            {/* Decorative Large Muted Number */}
            <span className="text-3xl md:text-4xl font-mono text-zinc-800 leading-none select-none font-normal">
              {project.number}
            </span>

            {/* Project Details */}
            <div className="flex-1 flex flex-col gap-3">
              {/* Header: Title + Type & View Link */}
              <div className="flex justify-between items-start">
                <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-3">
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg text-white font-medium hover:text-accent hover:underline transition-colors duration-300"
                  >
                    {project.title}
                  </a>
                  <span className="text-xs text-zinc-500 font-mono">
                    / {project.type}
                  </span>
                </div>

                <a
                  href={project.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-zinc-500 hover:text-accent font-mono transition-colors duration-300 flex items-center gap-1 select-none"
                >
                  view &rarr;
                </a>
              </div>

              {/* One-sentence Description */}
              <p className="text-zinc-400 text-sm md:text-base leading-relaxed font-normal">
                {project.description}
              </p>

              {/* Stack Pills */}
              <div className="flex flex-wrap gap-2 mt-1">
                {project.stack.map((tech, idx) => (
                  <span
                    key={idx}
                    className="px-2.5 py-0.5 border border-borderSubtle text-zinc-500 text-xs rounded-full font-mono font-normal select-none"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PortfolioHighlights;
